export default "__VITE_ASSET__q$LWlfuP__"